import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { ListItemIcon, MenuItem } from '@mui/material';

type HiddenMultipleProps = {
    onHide?: () => void;
    onShow?: () => void;
    selected?: number[];
    hidden?: number[];
    hideDisabled?: boolean;
};

export const HiddenMultiple = ({
    onHide,
    onShow,
    hidden = [],
    selected = [],
    hideDisabled,
}: HiddenMultipleProps): JSX.Element => {
    return (
        <div>
            <MenuItem
                onClick={onShow}
                disabled={selected.every((el) => !hidden.includes(el))}
            >
                <ListItemIcon sx={{ mx: -1 }}>
                    <VisibilityIcon />
                </ListItemIcon>
                Показать выбранные
            </MenuItem>
            <MenuItem
                onClick={onHide}
                disabled={
                    selected.every((el) => hidden.includes(el)) || hideDisabled
                }
            >
                <ListItemIcon sx={{ mx: -1 }}>
                    <VisibilityOffIcon />
                </ListItemIcon>
                Скрыть выбранные
            </MenuItem>
        </div>
    );
};
